import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput"]

  dispatchSearchEvent() {
    const event = new CustomEvent("airbnb:mobile-search:search-listings", { detail: { search_query: this.searchInputTarget.value } })

    window.dispatchEvent(event)
  }
}
